import {Injectable} from 'ng-metadata/core';

@Injectable()
export class ProgressCheckBoxService {
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/progressBar/progressCheckBox/progressCheckBox.service.ts